import fileDeleteDefaultIcon from "../../../assets/image/fileDeleteIcon.png";
import fileDeleteHoverIcon from "../../../assets/image/fileDeleteHoverIcon.png";
import defaultIcon from "./images/default-ico.png";
import docIcon from "./images/doc-ico.png";
import imgIcon from "./images/img-ico.png";
import pdfIcon from "./images/pdf-ico.png";
import pptIcon from "./images/ppt-ico.png";
import xlsxIcon from "./images/xlsx-ico.png";
import videoIcon from "./images/video-ico.png";
import BaseComponent from "../../common/BaseComponent";
import EllipsisToolTip from "../ellipsisToolTip";
import { PreviewFileLink } from "app/pages/previewFile";
import classNames from "classnames";

export default class FileItem extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      fileDeleteIcon: fileDeleteDefaultIcon,
    };
  }

  choseDocumentImg = (fileType: any) => {
    switch (fileType) {
      case "pdf":
        return pdfIcon;
      case "docx":
        return docIcon;
      case "doc":
        return docIcon;
      case "png":
        return imgIcon;
      case "jpeg":
        return imgIcon;
      case "jpg":
        return imgIcon;
      case "gif":
        return imgIcon;
      case "ppt":
        return pptIcon;
      case "pptx":
        return pptIcon;
      case "xlsx":
        return xlsxIcon;
      case "xls":
        return xlsxIcon;
      case "csv":
        return xlsxIcon;
      case "xlsm":
        return xlsxIcon;
      case "mp4":
        return videoIcon;
      default:
        return defaultIcon;
    }
  };

  render() {
    const { fileDeleteIcon } = this.state;
    const {
      fileName,
      fileType,
      index,
      isShowDeleteBtn,
      fileNameType,
      fileId,
      isDownload,
      className,
    } = this.props;
    return (
      <div className={classNames("fileList", className)} id={index}>
        <div className="fileListLeft">
          <div className="fileIcon">
            <img src={this.choseDocumentImg(fileType)} alt="File Icon" />
          </div>
          <div className="fileMsg">
            {fileNameType === "text" && (
              <p className="fileName" data-testid="file-name-text">
                {fileName}
              </p>
            )}
            {fileNameType === "link" && (
              <PreviewFileLink
                fileId={fileId}
                fileName={fileName}
                className="fileName"
                allowDownload={isDownload}
              >
                <EllipsisToolTip children={fileName} title={fileName} placement="top" />
              </PreviewFileLink>
            )}
          </div>
        </div>
        {isShowDeleteBtn && (
          <div className="fileListBtns">
            <div
              className="deleteFileIcon"
              title="Delete File"
              onMouseEnter={() => this.setState({ fileDeleteIcon: fileDeleteHoverIcon })}
              onMouseLeave={() => this.setState({ fileDeleteIcon: fileDeleteDefaultIcon })}
              onClick={this.props.deleteFile}
            >
              <img src={fileDeleteIcon} alt="Delete File" />
            </div>
          </div>
        )}
      </div>
    );
  }
}
